import { diffWords } from '@/lib/wordDiff';

/**
 * Wie viele Woerter der Diff entfernt und wie viele er ergaenzt hat.
 *
 * Der ERSATZTRAEGER fuer die Farbe im Titel-Diff. Wird die rote Flaeche
 * entfernt, verliert die Karte ihre einzige Aussage darueber, welche Woerter
 * entfielen - der Vorher-Block ist blockweit durchgestrichen, das <del> bringt
 * daran keine Optik-Aenderung (siehe Kommentar in `BeforeAfterDiff.tsx`). Ohne
 * Ersatz waere das ein WCAG-1.4.1-Bruch an gemessen drei Stellen je Karte.
 *
 * Gezaehlt werden WOERTER, nicht Tokens: `diffWords` liefert auch reine
 * Trennzeichen als eigene Tokens, und ein Zaehler, der ein geaendertes
 * Leerzeichen als "1 entfernt" meldet, nennt eine Zahl, die niemand im Text
 * wiederfindet.
 */
export function countTitleDiff(
  before: string,
  after: string,
): { entfernt: number; ergaenzt: number } {
  let entfernt = 0;
  let ergaenzt = 0;
  for (const token of diffWords(before ?? '', after ?? '')) {
    if (token.op === 'equal') continue;
    // Nur Tokens mit mindestens einem Nicht-Leerzeichen sind Woerter.
    if (token.text.trim() === '') continue;
    if (token.op === 'removed') entfernt += 1;
    else ergaenzt += 1;
  }
  return { entfernt, ergaenzt };
}
